import { defineComponent as f, toRefs as w, computed as s, h } from "vue";
import { SfIconSize as e } from "@storefront-ui/shared";
const m = f({
  name: "SfIconBase",
  props: {
    content: {
      type: String,
      default: void 0
    },
    size: {
      type: String,
      default: e.base
    }
  },
  setup(l, o) {
    const { size: u, content: n } = w(l), r = s(() => {
      var t, a;
      return (a = (t = o.slots).default) == null ? void 0 : a.call(t);
    }), c = s(() => {
      switch (u.value) {
        case e.xs:
          return "w-4 h-4";
        case e.sm:
          return "w-5 h-5";
        case e.lg:
          return "w-8 h-8";
        case e.xl:
          return "w-10 h-10";
        case e["2xl"]:
          return "w-14 h-14";
        case e["3xl"]:
          return "w-24 h-24";
        case e["4xl"]:
          return "w-48 h-48";
        default:
          return "w-6 h-6";
      }
    }), i = s(() => {
      const t = {
        xmlns: "http://www.w3.org/2000/svg",
        class: `inline-block fill-current ${c.value}`
      };
      return !r.value && n.value && (t.innerHTML = n.value), t;
    });
    return () => h("svg", i.value, r.value);
  }
});
export {
  m as default
};
